import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Button, InformationBox } from '@app/core';
import { Calendar } from 'queries';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  box: {
    marginTop: theme.marginBase * 2,
  },
  buttonLine: {
    marginTop: theme.marginBase * 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
}));
interface Props {
  name: string;
  calendars: Calendar[];
}

export const DisconnectedCalendarWarn = (props: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [{ value }] = useField(props.name);

  if (!value) {
    return null;
  }

  const calendar = props.calendars.find((c) => c.id === value);
  if (!calendar?.isDisconnected) {
    return null;
  }

  // TODO
  const relinkUrl = '';

  if (!relinkUrl) {
    return null;
  }

  return (
    <InformationBox
      variant="danger"
      title={t('editSession.settings.moderator.disconnected.title')}
      className={classes.box}
    >
      <p>{t('editSession.settings.moderator.disconnected.text')}</p>
      {relinkUrl && (
        <div className={classes.buttonLine}>
          <Button
            small
            color="inkInverted"
            variant="muted"
            href={relinkUrl}
            target="_blank"
          >
            {t('editSession.settings.moderator.disconnected.button')}
          </Button>
        </div>
      )}
    </InformationBox>
  );
};
